export default __webpack_public_path__ + "static/media/modern-phone.f6affaef.mp3";